import { useCallback, useRef } from 'react';

/**
 * Tracks the latest async request so stale responses can be ignored.
 */
export const useRequestVersion = () => {
  const versionRef = useRef(0);

  const startRequest = useCallback(() => {
    versionRef.current += 1;
    return versionRef.current;
  }, []);

  const invalidateRequests = useCallback(() => {
    versionRef.current += 1;
  }, []);

  const isCurrentRequest = useCallback(
    (requestVersion: number) => requestVersion === versionRef.current,
    [],
  );

  return { startRequest, invalidateRequests, isCurrentRequest };
};
